module.exports = __webpack_public_path__ + "static/ForThePeople3-9e72d5b03f96a64110dee137fec93021.webp";